"use client"

import styled from "@emotion/styled"
import { FinishLevel } from "@eurodrive/utils"
import { Typography } from "@mui/material"
import { Dispatch, SetStateAction } from "react"
import { Config, formatPrice } from "./CarConfiguration"

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
`

const ContentLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const FinishCard = styled.div<{ selected: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border: 1px solid ${({ selected }) => (selected ? "#000000" : "#ECE9E9")};
  border-radius: 8px;
  background-color: #ffffff;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: #000000;
  }
`

export default function FinishStage({
  markComplete,
  finishLevels,
  config,
  setConfig,
}: {
  markComplete: () => void
  finishLevels: FinishLevel[]
  config: Config
  setConfig: Dispatch<SetStateAction<Config>>
}) {
  const handleSelect = (index: number) => {
    setConfig((prev) => ({
      ...prev,
      finishLevel: index,
    }))
    markComplete()
  }

  return (
    <StyledLayout>
      <Typography variant="h2" component="h2">
        בחירת גימור
      </Typography>
      <ContentLayout>
        {finishLevels && finishLevels.length > 0 ? (
          finishLevels.map((finish, index) => (
            <FinishCard
              key={index}
              selected={config.finishLevel === index}
              onClick={() => handleSelect(index)}
            >
              <Typography variant="body1">
                {finish.monthlyPrice > 0
                  ? `₪${formatPrice(finish.monthlyPrice)} חודשי`
                  : "כלול במחיר"}
              </Typography>
              <Typography variant="body2">{finish.name}</Typography>
            </FinishCard>
          ))
        ) : (
          <Typography
            variant="body3"
            style={{ textAlign: "center", padding: "20px", color: "#666" }}
          >
            לא נמצאו אפשרויות גימור
          </Typography>
        )}
      </ContentLayout>
    </StyledLayout>
  )
}
